import React from "react";
import { TradeInAemModelSelectType } from "../../../utils/constants";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import * as Styles from "./styles/ModelSelect";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { tradeInAemModelSelectSelectCarType } from "../../../redux/actions/TradeInAemModelSelectActions";
import { getInternalLink } from "../../../utils/navUtils";
import { tradeInAemModelSelectLabels, useTradeInAemLabel } from "../../../utils/labels";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { trackSelectVehicleType } from "../../../utils/tracking";
import { tradeInAemUpdateExtraInfoProp } from "../../../redux/actions/TradeInAemVehicleActions";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { useDispatch } from "../../../../shared-logic/redux/store";

type Props = {
    carType: TradeInAemModelSelectType;
};

const TradeInAemModelSelectCtaBlock = ({ carType }: Props): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const csl = useTradeInCsl();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const selectedCarType = useTradeInAemSelector((state) => state.tradeInAemModelSelect.selectedCarType);
    const [selectLabel, selectedLabel, titleLabel] = useTradeInAemLabel([
        "tradeInAemModelSelectSelect",
        "tradeInAemModelSelectSelected",
        tradeInAemModelSelectLabels[carType],
    ]);
    const nextStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "next");
    const isSelected = selectedCarType === carType;
    const trackingParams = useTrackingParams();

    return (
        <Styles.SelectCard isSelected={isSelected}>
            <Styles.SelectCardTitle>{titleLabel}</Styles.SelectCardTitle>
            <Button.Primary
                m={0}
                width={{ _: "100%", md: "auto", lg: "100%" }}
                light={!!selectedCarType}
                type="button"
                onClick={(event) => {
                    dispatch(tradeInAemModelSelectSelectCarType(carType));
                    dispatch(tradeInAemUpdateExtraInfoProp("selectedCarType", carType));
                    trackSelectVehicleType(trackingParams, carType);

                    // Used car option doesnt show a list of cars, go straight to the next step.
                    // If the option is none, we skip to the next step.
                    // Stock/new shows a list of models instead of going to the next step.
                    if (
                        (carType === TradeInAemModelSelectType.Used || carType === TradeInAemModelSelectType.None) &&
                        nextStep.onClick
                    ) {
                        nextStep.onClick(event);
                    }
                }}
            >
                <Text.Button>{isSelected ? selectedLabel : selectLabel}</Text.Button>
            </Button.Primary>
        </Styles.SelectCard>
    );
};

export default TradeInAemModelSelectCtaBlock;
